import { MessageBox } from '../message-box/message-box';
import { ServiceResult } from './ServiceResult'
import { UnAuthorizedServiceResult } from './un-authorized-service-result'
import { UnauthenticatedServiceResult } from './un-authenticated-service-result'
import { Injectable } from '@angular/core'
import { LocalRepository } from '../data/repository/local-repository';


@Injectable()
export class ErrorHandler {
    constructor(private messageBox: MessageBox,private repo:LocalRepository) {
    }

    public handleError(result: ServiceResult): void {
       ;
        if (result instanceof UnAuthorizedServiceResult){
            this.messageBox.showError("مدیریت امنیت", "دسترسی مجاز نیست.");
        }
        else if (result instanceof UnauthenticatedServiceResult) {
          this.repo.remove('access_token');
            this.messageBox.showError("مدیریت امنیت", "لطفا مجددا احراز هویت نمایید.");
        }
        else {
            this.messageBox.showError("خطا", result.response);
        }
        
    }
    
}
